import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

const EMPTY_QUERY_STATE = {
  docs: null,
  loading: true,
  error: "",
};

const EMPTY_DOCUMENT_STATE = {
  doc: null,
  loading: true,
  error: "",
};

export const selectQueryState = (state, name) => state.firestore[name] || EMPTY_QUERY_STATE;

export const selectDocumentState = (state, name) => state.firestore[name] || EMPTY_DOCUMENT_STATE;

const buildIdMap = (docs) => {
  const idMap = {};
  docs.forEach((doc) => idMap[doc.id] = doc);
  return idMap;
}


const firestoreSlice = createSlice({
  name: "firestore",
  initialState: initialState,
  reducers: {
    clear() {
      return initialState;
    },
    setQueryState(state, action) {
      const { name, docs, loading, error } = action.payload;
      state[name] = {
        docs,
        idMap: buildIdMap(docs),
        loading,
        error: error || "",
      };
    },
    setDocumentState(state, action) {
      const { name, doc, loading, error } = action.payload;
      state[name] = {
        doc,
        loading,
        error: error || "",
      };
    },
  },
});

export const firestoreActions = firestoreSlice.actions;

export default firestoreSlice.reducer;
